import { FormValues } from '../useCopyPasteMetadata';

export const isEmptyForm = (obj: FormValues) => {
  return obj
    ? Object.keys(obj).length === 0 || Object.values(obj).every((v) => !v)
    : true;
};
